module.exports = __webpack_public_path__ + "img/portrait-024.a83dbafb.jpg";